import React from "react";
import { useAuth } from "../../../context/AuthContext";
import InfanionLogo from "../../static/svg/InfanionLogo";

const DynamicLogo = () => {
  const { user } = useAuth();
  
  if (user.isLoggedIn && user.account?.logo) {
    return (
      <img 
        src={user.account.logo} 
        alt="Dashboard Logo" 
        style={{ height: "60px", width: "auto" }} 
      />
    );
  }
  
  return <InfanionLogo />;
};

export default DynamicLogo;